export default {
  seeUnarchivedCampaigns: 'Nicht archivierte Kampagnen anzeigen',
  seeArchivedCampaigns: 'Archivierte Kampagnen anzeigen',
  sendMassSms: 'Massive SMS senden',
  mustChargeBeforeSendingCampaigns: 'Sie müssen neu laden, bevor Sie Kampagnen senden',
  sendSmsCampaignFromFile: 'Senden von SMS-Kampagnen aus einer Datei',
  createCampaign: 'Kampagne erstellen',
  sendCampaignToDirectory: 'Kampagne an Ihr Verzeichnis senden',
  forms: 'Formen',
  unArchive: 'Unarchivieren',
  archive: 'Datei',
  loadingCampaigns: 'Laden von Kampagnen',
  noCampaignsCreated: 'Sie haben keine Kampagne erstellt',
  type: 'Typ',
  status: 'Staat',
  campaignSuccessfullyArchived: 'Erfolgreich archivierte Kampagne',
  sendCampaign: 'Sendekampagne',
  shippingDateAndTime: 'Datum und Uhrzeit der Lieferung',
  scheduleCampaign: 'Planen der Kampagne',
  campaignReadyAndWaitingToBeSent: 'Ihre Kampagne ist bereit und wartet darauf, gesendet zu werden',
  schedule: 'Programm',
  export: 'Exportieren',
  campaignStatus: 'Kampagnenstatus',
  campaignScope: 'Kampagnenreichweite',
  messagesToBeSent: 'Zu sendende Nachrichten',
  thisValueCouldChange: 'Dieser Wert kann sich ändern',
  finalValue: 'Endwert',
  sendingDate: 'Versanddatum',
  campaignProgress: 'Fortschritte bei der Kampagne',
  moreCounters: 'Mehr Buchhalter',
  lessCounters: 'Weniger Buchhalter',
  importingPeopleProgress: 'Fortschritte bei der Einfuhr von Personen',
  importedPeople: 'Importierte Personen',
  peopleAmount: 'Personen insgesamt',
  importingErrors: 'Importfehler',
  sending: 'Senden',
  sent: 'Gesendet | Gesendet | gesandt',
  onStandBy: 'Freue mich auf',
  onDraft: 'Entwurf',
  scheduled: 'Geplant',
  all: 'Alle',
  pending: 'Steigung',
  deliveredToCarrier: 'Lieferung an den Spediteur',
  rejected: 'Abgelehnt | Abgelehnt',
  postponed: 'Latent | Latent',
  hardRebound: 'Starker Sprung | Starke Sprünge',
  softRebound: 'Weiche Bounce | Weiche Sprünge',
  opened: 'Öffnen | Öffnen',
  inSpam: 'In Spam',
  terminated: 'Beendet | Beendet',
  inBlackList: 'Steht auf der schwarzen Liste',
  inWhiteList: 'Whitelist',
  messagePart: 'Nachrichtenteil | Nachrichtenteile',
  delivered: 'Geliefert',
  importMorePeople: 'Importieren Sie mehr Personen',
  loadingUsers: 'Laden von Benutzern',
  clicked: 'Geklickt',
  multiParts: 'Mehrere Teile',
  seeMessage: 'Siehe Nachricht',
  noUserDefinedMessage: 'Der Benutzer hat keine definierte Nachricht',
  youAreSeeingTheMessageOf: 'Sie sehen die Nachricht',
  nameOfTheMassSms: 'Massen-SMS-Name',
  insertMassSmsKeyName: 'Geben Sie einen Namen ein, um sich daran zu erinnern, worum es bei dieser massiven SMS geht',
  noFilePicked: 'Sie haben keine Datei ausgewählt',
  downloadFormat: 'Download-Format',
  prepareMassSms: 'Vorbereiten massiver SMS',
  insertMassSmsName: 'Geben Sie den Namen der Massen-SMS ein,',
  mustPickSmsFile: 'Sie müssen die SMS-Datei',
  campaignSuccessfullyCreated: 'Erfolgreich erstellte Kampagne',
  campaignName: 'Kampagnenname',
  insertMassCampaignKeyName: 'Geben Sie einen Namen ein, um sich daran zu erinnern, worum es bei dieser Kampagne geht',
  campaignType: 'Kampagnentyp',
  pickCampaignType: 'Wählen Sie den Kampagnentyp aus',
  writeYourMessageHere: 'Schreiben Sie Ihre Nachricht hier',
  pickPeopleList: 'Wählen Sie eine Liste von Personen',
  pickOrCreateListOfPeopleToCommunicateMessage: 'Wählen Sie die Liste der Personen aus, an die Sie Ihre Nachricht übermitteln möchten, oder erstellen Sie eine neue Liste, indem Sie sie aus einer externen Datei importieren.',
  allPeople: 'Alle Menschen',
  waitWhileTheListGetsCreated: 'Warten, während die Liste erstellt wird',
  noPeopleListPicked: 'Sie haben keine Personenliste ausgewählt',
  addYourFirstCondition: 'Fügen Sie Ihre erste Bedingung hinzu',
  addAnotherCondition: 'Hinzufügen einer anderen Bedingung',
  attributeCondition: 'Attributbedingung',
  actionCondition: 'Handlungszustand',
  segmentPeopleByAttributesAndActions: 'Sie können Personen ansprechen, die mit Ihrem Unternehmen interagieren, entweder durch ihre Attribute oder durch Aktionen, die innerhalb Ihrer Plattform ausgeführt werden.',
  youAreAlmostDone: 'Sie sind fast fertig!',
  yourMessageScope: 'Ihre Nachricht erreicht die Menschen',
  prepareCampaign: 'Vorbereiten der Kampagne',
  insertMessageSubject: 'Geben Sie den Betreff Ihrer Nachricht ein',
  insertMessageHtml: 'Geben Sie den HTML-Code Ihrer Nachricht ein',
  createHtmlTemplate: 'Erstellen Sie Ihre Vorlage',
  importPeople: 'Importieren von Personen',
  insertCampaignName: 'Geben Sie den Kampagnennamen ein',
  insertCampaignType: 'Geben Sie den Kampagnentyp ein',
  subject: 'Angelegenheit',
  insertHtmlTemplate: 'Einfügen der HTML-Vorlage in das nächste Feld',
  previewTemplate: 'Vorschauvorlage',
  customize: 'Anpassen',
  from: 'Von',
  until: 'Bis',
  attribute: 'Attribut',
  contains: 'Enthält',
  noContains: 'Enthält keine',
  is: 'Ist',
  isNot: 'Es ist nicht',
  addANameToYourTemplate: 'Fügen Sie Ihrer Vorlage einen Namen hinzu',
  templateName: 'Vorlagenname',
  save: 'Speichern',
  // Triggers
  triggers: 'Trigger',
  noTitle: 'Untitled',
  loadingTriggers: 'Laden von Triggern',
  noRegisteredTriggers: 'Keine registrierten Trigger',
  title: 'Titel',
  executeTriggerWhenActionFire: 'Trigger ausführen, wenn es sich um eine Aktion handelt',
  customActionToFilter: 'Benutzerdefinierte Aktion zum Filtern',
  actionsToExecute: 'Auszuführende Aktionen',
  emailBody: 'E-Mail-Text',
  smsBody: 'SMS-Gehäuse',
  postRequestData: 'POST-Anforderungsdaten',
  saveTrigger: 'Trigger speichern',
  trigger: 'Trigger',
  new: 'Neu',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  triggerDetails: 'Triggerdetails',
  triggerScope: 'Triggerbereich',
  editTrigger: 'Trigger bearbeiten',
  createTrigger: 'Trigger erstellen',
  triggerSuccessfullyCreated: 'Trigger erfolgreich erstellt',
  triggerSuccessfullyUpdated: 'Trigger erfolgreich aktualisiert',
  launchers: 'Trägerraketen',
  actionType: 'Aktion {Aktion}',
  addNotification: 'Hinzufügen einer Benachrichtigung',
  notifications: 'Benachrichtigungen',
  loadingNotifications: 'Laden von Benachrichtigungen',
  noNotificationsCreated: 'Keine Benachrichtigungen erstellt',
  newNotification: 'Neue Benachrichtigung',
  notificationCreatedSuccessfully: 'Benachrichtigung korrekt erstellt',
  editNotification: 'Benachrichtigung bearbeiten',
  notificationEditedSuccessfully: 'Benachrichtigung korrekt bearbeitet',
  youDontHaveNotifications: 'Sie haben keine Benachrichtigungen',
  invalidFileType: 'Ungültiger Dateityp',
  noDataFound: 'Keine Daten gefunden',
  clickOnYourFileTypeOrDragHere: 'Klicken Sie auf Ihren Dateityp oder ziehen Sie ihn hierher',
  filesSize: 'Dateien, die größer als 5 Mbs sind, werden nicht unterstützt',
  findQuickAnswer: 'Suche nach schneller Antwort',
  noAnswerFound: 'Wir haben nicht die Antwort gefunden, nach der Sie suchen',
  titleNewInformation: 'Titel der neuen Information',
  waitingForAttention: 'Warten auf Aufmerksamkeit',
  terminationReason: 'Grund für die Fertigstellung',
  findTerminationReason: 'Grund für die Kündigung finden',
  nameless: 'Kein Name',
  conversationClassification: 'Klassifikation von Gesprächen',
  withoutAdvisor: 'Kein Berater',
  you: 'Sie',
  agents: 'Vertreter',
  advisors: 'Berater',
  conversations: 'Gespräche',
  host: 'Host',
  attended: 'Besucht',
  noAttended: 'Unbeaufsichtigt',
  responseTime: 'Antwortzeit',
  noAttendedConversations: 'Keine Gespräche',
  attendedConversations: 'Gespräche',
  totalConversations: 'Gesamtgespräche',
  lastMonth: 'Letzter Monat',
  phone: 'Telefon',
  organic: 'Organisch',
  conversationsPerChannel: 'Gespräche nach Kanal',
  createdPeople: 'Personen erstellt',
  waitTime: 'Wartezeit',
  yesterday: 'Vorheriger Tag',
  withBot: 'Mit Bot',
  assignTaskAfterSettingJourney: 'Aufgabe nach dem Einstellen der Reise zuweisen',
  pickAJourneyStatus: 'Wählen Sie einen Reisestatus',
  journeys: 'Reisen',
  timeInMinutesToCreateTaskAfterSettingJourney: 'Zeit in Minuten, um eine Aufgabe nach dem Einstellen der Reise zu erstellen',
  untrainedQuestions: 'Ungeübte Fragen',
  numberOfQuestions: 'Anzahl der Fragen',
  serviceRating: 'Qualifikation des Dienstes',
  usersWhoGotProactivity: 'Benutzer, die proaktiv wurden',
  bot: 'Roboter',
  questions: 'Fragen',
  operator: 'Betreiber',
  time: 'Zeit',
  attendedAndUnansweredConversations: 'Besuchte und nicht besuchte Gespräche',
  total: 'Gesamt',
  pickExtraData: 'Wählen Sie zusätzliche Daten aus',
  pickExtraDataFieldAndValue: 'Wählen Sie zusätzliches Datenfeld und Wert',
  writeExtraDataValue: 'Schreiben Sie einen zusätzlichen Datenwert',
  campaignInformation: 'Kampagneninformationen',
  // Trigger to do list translations
  smsToUser: 'SMS an Benutzer',
  emailToUser: 'E-Mail an Benutzer',
  postRequestToServer: 'Anfrage an Server senden',
  createTaskForUser: 'Aufgabe für Benutzer erstellen',
  // Trigger action types translations
  ACTION_CUSTOM: 'Benutzerdefinierte Aktion',
  ACTION_REGISTER_EMAIL: 'Bei E-Mail-Registrierung',
  ACTION_REGISTER_PHONE: 'Bei Telefonregistrierung',
  ACTION_REGISTER_VERIFIED: 'Bei Registrierung überprüft',
  ACTION_REGISTER_EMAIL_RESEND: 'Beim erneuten Senden der Registrierungs-E-Mail',
  ACTION_REGISTER_SOCIAL: 'Bei Registrierung mit sozialen Netzwerken',
  ACTION_REGISTER_GOOGLE: 'E-Mail an Benutzer0',
  ACTION_REGISTER_FACEBOOK: 'E-Mail an Benutzer1',
  ACTION_REGISTER_SPOTIFY: 'E-Mail an Benutzer2',
  ACTION_REGISTER_INSTAGRAM: 'E-Mail an Benutzer3',
  ACTION_REGISTER_APPLEID: 'E-Mail an Benutzer4',
  ACTION_REGISTER_EMAIL_FAIL: 'E-Mail an Benutzer5',
  ACTION_REGISTER_PHONE_FAIL: 'E-Mail an Benutzer6',
  ACTION_LOGIN_EMAIL: 'E-Mail an Benutzer7',
  ACTION_LOGIN_PHONE: 'E-Mail an Benutzer8',
  ACTION_LOGIN_SOCIAL: 'E-Mail an Benutzer9',
  ACTION_LOGIN_GOOGLE: 'Anfrage an Server senden0',
  ACTION_LOGIN_FACEBOOK: 'Anfrage an Server senden1',
  ACTION_LOGIN_INSTAGRAM: 'Anfrage an Server senden2',
  ACTION_LOGIN_SPOTIFY: 'Anfrage an Server senden3',
  ACTION_LOGIN_APPLEID: 'Anfrage an Server senden4',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: 'Anfrage an Server senden5',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: 'Anfrage an Server senden6',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: 'Anfrage an Server senden7',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: 'Anfrage an Server senden8',
  ACTION_LOGIN_EMAIL_FAIL: 'Anfrage an Server senden9',
  ACTION_LOGIN_EMAIL_FAIL_USER: 'Aufgabe für Benutzer erstellen0',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: 'Aufgabe für Benutzer erstellen1',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: 'Aufgabe für Benutzer erstellen2',
  ACTION_LOGIN_PHONE_FAIL: 'Aufgabe für Benutzer erstellen3',
  ACTION_LOGIN_PHONE_FAIL_USER: 'Aufgabe für Benutzer erstellen4',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: 'Aufgabe für Benutzer erstellen5',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: 'Aufgabe für Benutzer erstellen6',
  ACTION_RESET_PASSWORD_PHONE: 'Aufgabe für Benutzer erstellen7',
  ACTION_RESET_PASSWORD_EMAIL: 'Aufgabe für Benutzer erstellen8',
  ACTION_RESET_VALIDATION: 'Aufgabe für Benutzer erstellen9',
  ACTION_RESET_OTP: 'Benutzerdefinierte Aktion0',
  ACTION_LOGOUT: 'Benutzerdefinierte Aktion1',
  ACTION_SUBMIT: 'Benutzerdefinierte Aktion2',
  ACTION_SUBMIT_FILE: 'Benutzerdefinierte Aktion3',
  ACTION_USER_IMAGE: 'Benutzerdefinierte Aktion4',
  ACTION_EVENT_PURCHASE: 'Benutzerdefinierte Aktion5',
  ACTION_EVENT_PURCHASE_CONFIRMATION: 'Benutzerdefinierte Aktion6',
  ACTION_USER_CHANGE: 'Benutzerdefinierte Aktion7',
  ACTION_ON_JOURNEY_SET: 'Benutzerdefinierte Aktion8',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: 'Benutzerdefinierte Aktion9',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: 'Bei E-Mail-Registrierung0',
  attachFiles: 'Dateien anhängen',
  attachFilesInCampaignDescription: `
  Um Dateien an Ihre E-Mail-Kampagne anzuhängen,
  Jede Datei, die Sie anhängen, kann nur 5 MB und die Gesamtgröße der Dateien wiegen
  muss weniger als {size} {units} wiegen.
  `,
  sizeOfFileCantExceed: 'Die Größe jeder Datei darf {size} {units} nicht überschreiten.',
  filesTotalSizeMustBeSmallerThan: 'Die Gesamtgröße Ihrer Dateien darf {size} {units} nicht überschreiten.',
  attachedFiles: 'Beigefügte Anhänge',
  fileSuccessfullyDeleted: 'Datei erfolgreich gelöscht',
  fileWithSameNameAlreadyExists: 'Eine gleichnamige Datei ist bereits vorhanden',
  filesSuccessfullyAttached: 'Datei erfolgreich angehängt'
}
